import { combineReducers } from 'redux';
import { voiceModeChangeNotifyMessage } from './app/app-reducers';

const staticReducers = {
  voiceModeChangeNotifyMessage
};

export default function createReducer(asyncReducers) {
  const reducers = {
    ...staticReducers,
    ...asyncReducers
  };
  return combineReducers(reducers);
}
